import Vue from "vue";
import Vuex from "vuex";
import { Howl } from "howler";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    numScenes: 4,
    currentScene: 1,
    beginButton: true,
    muted: false,
    actioned: false,
    trackTime: 0,
    trackInterval: null,
    audio: {
      //Boogie Woogie
      jPiano: new Howl({
        src: ["audio/boogie-woogie-piano.mp3"],
        html5: true,
        loop:true,
        volume: 0
      }),
      jBass: new Howl({
        src: ["audio/boogie-woogie-bass.mp3"],
        html5: true,
        loop:true,
        volume: 0
      }),
      jDrums: new Howl({
        src: ["audio/boogie-woogie-drums.mp3"],
        html5: true,
        loop: true,
        volume: 0
      }),
      jGuitar: new Howl({
        src: ["audio/boogie-woogie-guitar.mp3"],
        html5: true,
        loop: true,
        volume: 0
      }),
      //CLASSICAL
      classicalStrings: new Howl({
        src: ["audio/classical-strings.mp3"],
        html5: true
      }),
      classicalBrass: new Howl({
        src: ["audio/classical-brass.mp3"],
        html5: true
      }),
      classicalPercussion: new Howl({
        src: ["audio/classical-percussion.mp3"],
        html5: true
      }),
      classicalWoodwinds: new Howl({
        src: ["audio/classical-woodwinds.mp3"],
        html5: true
      }),
      classicalAll: new Howl({
        src: ["audio/classical-all.mp3"],
        html5: true
      }),
      //RAP
      rapVoice: new Howl({
        src: ["audio/rap-voice.mp3"],
        loop:true,
        html5: true,
        volume: 0
      }),
      rapScratch: new Howl({
        src: ["audio/rap-scratch.mp3"],
        loop:true,
        html5: true,
        volume: 0
      }),
      rapMusic: new Howl({
        src: ["audio/rap-music.mp3"],
        loop:true,
        html5: true,
        volume: 0
      }),
    }
  },
  mutations: {
    SET_CURRENT_SCENE(state, payload) {
      state.currentScene = payload;
    },
    PREVIOUS_SCENE(state) {
      state.currentScene--;
    },
    NEXT_SCENE(state) {
      state.currentScene++;
    },
    HIDE_BEGIN_BUTTON(state) {
      state.beginButton = false;
    },
    MUTE(state) {
      state.muted = true;
    },
    UNMUTE(state) {
      state.muted = false;
    },
    SHOW(state) {
      state.actioned = true;
    },
    HIDE(state) {
      state.actioned = false;
    },
    RESET_TRACK_TIME(state) {
      state.trackTime = 0;
    },
    RESET_TRACK_INTERVAL(state) {
      clearInterval(state.trackInterval);
      state.trackInterval = setInterval(() => {
        state.trackTime += 0.5;
      }, 500);
    },
    CLEAR_TRACK_INTERVAL(state) {
      clearInterval(state.trackInterval);
    }
  },
  actions: {
    begin({ state, commit }) {
      commit("HIDE_BEGIN_BUTTON");
      state.audio.scene1.play();
      commit("RESET_TRACK_INTERVAL");
      commit("RESET_TRACK_TIME");
    },
    backStudio({ commit, dispatch }) {
      commit("SET_CURRENT_SCENE", 1);
        dispatch("stopAllAudio");
    },
    boogieScenes({ commit,dispatch }) {
      commit("SET_CURRENT_SCENE", 2);
      dispatch("stopAllAudio");
    },
    classicalScenes({ commit, dispatch }) {
      commit("SET_CURRENT_SCENE", 3);
      dispatch("playAudioByScene");
    },
    rapScenes({ commit, dispatch }) {
      commit("SET_CURRENT_SCENE", 4);
      dispatch("stopAllAudio");
    },
    toggleMute({ state, commit }) {
      if (state.muted) {
        // Howler.mute(false);
        commit("UNMUTE");
      } else {
        // Howler.mute(true);
        commit("MUTE");
      }
    },
    stopAllAudio({ state, commit }) {
      Object.keys(state.audio).forEach(key => {
        state.audio[key].stop();
      });
      commit("CLEAR_TRACK_INTERVAL");
      commit("RESET_TRACK_TIME");
    },
    playAudioByScene({ state, commit, dispatch }) {
      dispatch("stopAllAudio");
      if (typeof state.audio[`scene${state.currentScene}`] !== "undefined") {
        state.audio[`scene${state.currentScene}`].play();
        commit("RESET_TRACK_INTERVAL");
        commit("RESET_TRACK_TIME");
      }
    },
    playAudioByName({ state }, name) {
      if (typeof state.audio[name] !== "undefined") {
        state.audio[name].play();
      }
    },
    setVolumeByName({ state }, payload) {
      // console.log(payload)
      if (typeof state.audio[payload.name] !== "undefined") {
        state.audio[payload.name].volume(payload.volume);
      } else {
        Object.keys(state.audio).forEach(key => {
          state.audio[key].stop();
        })
      }
    },
    playAudioClassical({ state }, name) {
       if (state.audio[name].playing()) {
          state.audio[name].stop();
        } 
        else {
          state.audio[name].play();
        }
    },
    toggleAudioByName({ state  }, name) {
      if (typeof state.audio[name] !== "undefined") {
        if (state.audio[name].playing()) {
          state.audio[name].stop();
        } else {
          Object.keys(state.audio).forEach(key => {
            state.audio[key].stop();
          });
          state.audio[name].play();
        }
      }
    }
  }
});

export default store;
